const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1, viewport-fit=cover';

/**
 * iOS Safari often stays zoomed after focusing inputs (<16px or keyboard),
 * leaving the page cropped and untappable until the user pinch-zooms out.
 */
export const resetMobileViewport = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const active = document.activeElement;
  if (active && typeof active.blur === 'function' && active !== document.body) {
    active.blur();
  }

  document.documentElement.scrollLeft = 0;
  document.body.scrollLeft = 0;
  const y = window.scrollY || window.pageYOffset || 0;
  if ((window.scrollX || window.pageXOffset || 0) !== 0) {
    window.scrollTo(0, y);
  }

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const previous = meta.getAttribute('content') || DEFAULT_VIEWPORT;
  meta.setAttribute(
    'content',
    'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover'
  );

  window.setTimeout(() => {
    meta.setAttribute('content', previous.includes('initial-scale') ? previous : DEFAULT_VIEWPORT);
  }, 350);
};
